export enum NavBarItem {
  DASHBOARD = 'nav_dashboard',
  MEMBER_DETAIL = 'nav_member_detail',
  SHARE = 'nav_share_activity',
  LIST = 'nav_back_to_list',
  CREATE_NEW_ACTIVITY = 'nav_create_new_activity',
}
